import { Pagination } from '@components/Table/Pagination';
import { TableCellAction } from '@components/Table/TableCellAction';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { TableWrapper } from '@components/Table/TableWrapper';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IMenu } from '@hooks/useMenu';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IUsuario } from '@model/Usuario';
import { useUsuarioStatusColor } from '@model/UsuarioStatus';
import { IUsuarioFilter } from '@services/UsuarioService';
import React from 'react';

export type UsuarioTableProps = {
    data: IData<IUsuario, IUsuarioFilter>
    isLoading: boolean
    menu: IMenu
}

export function UsuarioTable ({ data, isLoading, menu }: UsuarioTableProps) {
    const formatter = useFormatter();
    const usuarioStatusColor = useUsuarioStatusColor();

    return (
        <TableWrapper>
            <TableLinearLoading isLoading={isLoading} />
            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <Pagination pagination={data.pagination} />

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="usuarioId">ID</TableSortCell>
                        <TableSortCell fieldName="nome">Nome</TableSortCell>
                        <TableSortCell fieldName="nomeUsuario">Nome de Usuário</TableSortCell>
                        <TableSortCell fieldName="ultimoLogin">Últ. Login</TableSortCell>
                        <TableSortCell fieldName="usuarioStatusNome">Status</TableSortCell>
                        <TableHeaderCellAction />
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((usuario, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell>{usuario.usuarioId}</TableKeyCell>
                                    <TableCell>{usuario.nome}</TableCell>
                                    <TableCell>{usuario.nomeUsuario}</TableCell>
                                    <TableCell>{formatter.toDate(usuario.ultimoLogin)}</TableCell>
                                    <TableCell className={usuarioStatusColor[usuario.usuarioStatusId]}>{usuario.usuarioStatusNome}</TableCell>
                                    <TableCellAction onButtonClick={data.handleRowFocused(usuario, menu.open)} />
                                </TableRow>
                            )
                        })
                    }

                    <Pagination pagination={data.pagination} />

                </TableBody>
            </TableNoResult>
        </TableWrapper>
    )
}